import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { useColorTheme } from '@hooks';
import { generateCustomInputNodeHandle, NODE_HANDLE_IDS } from '../../index';
import styled from 'styled-components';
import { Body5 } from '@ui';

const Wrapper = styled.div`
  position: relative;
`;
const Label = styled.div`
  position: absolute;
  top: 7.5px;
  left: 14px;
  pointer-events: auto;
  cursor: pointer;
  user-select: none;

  &:hover {
    opacity: 0.8;
  }
`;

const DEFAULT_HANDLE_STYLE = {
  top: '17px',
  left: '4px',
};
export default React.memo(({ data, isConnectable, nodeId, onRemoveConnectedEdges }) => {
  const colorTheme = useColorTheme();
  const id = NODE_HANDLE_IDS.planStep;
  const { colorThemeName } = generateCustomInputNodeHandle(id);

  const handleDoubleClick = () => {
    if (onRemoveConnectedEdges) {
      onRemoveConnectedEdges(nodeId, id, 'target');
    }
  };

  return (
    <Wrapper>
      <Label onDoubleClick={handleDoubleClick}>
        <Body5 bold uppercase>
          Input
        </Body5>
      </Label>
      <Handle
        type="target"
        id={id}
        position={Position.Left}
        style={{ ...DEFAULT_HANDLE_STYLE, background: colorTheme[colorThemeName] }}
        isConnectable={isConnectable}
      />
    </Wrapper>
  );
});
